module.exports = __webpack_public_path__ + "img/francoeur_6_cover.d2c5e53d.jpg";